<template>
  <main class="content overview">
      <div v-if="loading" class="loading is-flex">
        <div class="spinner">
            <div class="mask">
                <div class="maskedCircle"></div>
            </div>
        </div>
      </div>

      <section class="heading has-padding">
        <h1>Inspektionen</h1>
      </section>

      <section class="list">
          <header class="is-flex has-padding">
              <div class="col-2">
                <h2>Aktuell</h2>
              </div>
              <div class="col-2 align-right m-adj">
                <a @click="fetch_GET_both_Facilities()" class="link" href="#">Aktualisieren</a>
              </div>
          </header>

          <div v-if="unsent_facilities && unsent_facilities.length > 0" class="list-entries">
                <div v-for="(facility, idx) in unsent_facilities"
                    class="list-entry has-padding"
                    :key="idx"
                    >
                    <div class="inner-list-entry">
                        <h2 @click="show_PDF(facility.pdfFile.fullPath)">{{facility.ANL_BEZEICHNUNG}}</h2>
                        <p>{{formateDate(facility.date)}} von {{facility.userFirstname}} {{facility.userLastname}}</p>
                        <span class="icon is-flex" @click="fetch_POST_PDF(facility._id)">
                            <img src="../assets/send-icon-active.svg" alt="PDF senden" class="fa-send">
                        </span>
                    </div>
                </div>
          </div>
          <div v-else class="list-entries">
                <div class="list-entry has-padding">
                    <div class="inner-list-entry">
                        <h2>Keine Einträge vorhanden</h2>
                        <p>Es konnten keine aktuellen Einträge gefunden werden.</p>
                    </div>
                </div>
          </div>
      </section>

      <section class="list">
          <header class="is-flex has-padding">
              <div class="col-2">
                <h2>Archiv (gesendet)</h2>
              </div>
              <div class="col-2 align-right">
              </div>
          </header>

          <div class="list-entries">
            <div v-if="sent_facilities && sent_facilities.length > 0" class="list-entries">
                <div v-for="(facility, idx) in sent_facilities"
                    class="list-entry has-padding"
                    :key="idx"
                    >
                    <div class="inner-list-entry">
                        <h2 @click="show_PDF(facility.pdfFile.fullPath)">{{facility.ANL_BEZEICHNUNG}}</h2>
                        <p>{{formateDate(facility.date)}} von {{facility.userFirstname}} {{facility.userLastname}}</p>
                        <span class="icon is-flex" @click="fetch_POST_PDF(facility._id)">
                            <img src="../assets/send-icon-active.svg" alt="PDF senden" class="fa-send">
                        </span>
                    </div>
                </div>
            </div>
            <div v-else class="list-entries">
                <div class="list-entry has-padding">
                    <div class="inner-list-entry">
                        <h2>Keine Einträge vorhanden</h2>
                        <p>Es konnten keine archivierten Einträge gefunden werden.</p>
                    </div>
                </div>
          </div>
          </div>
      </section>

      <div @click="goToPath('inspektionanlage')" class="button is-primary is-flex">
          <h3>Neue Inspektion erstellen</h3>
      </div>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'inspektionen',
  data() {
    return {
        loading: false,
        sent_facilities: null,
        unsent_facilities: null,
        error: null
    }
  },
  created () {
      window.scrollTo(0, 0);
      this.fetch_GET_sent_Facilities()
      this.fetch_GET_unsent_Facilities()
  },
  methods: {
    goToPath (route) {
        this.resetData()

        this.$router.push(route);
    },
    viewRoute (facility, type) {
        this.$store.state.is_Edit_active = false
        this.$store.state.facilities_inspection = facility

        if (type === 'mauer') {
            this.$store.state.check_mauer = facility.check

            this.$router.push('inspektion_mauer')
        } else {
            this.$store.state.check_durchlass = facility.check

            this.$router.push('inspektion_durchlass')
        }
    },
    fetch_GET_sent_Facilities () {
        this.loading = true

        axios.get('https://www.lola-inspect.at/api/facilities/inspections/sent', { headers: { Authorization: this.$store.state.authToken } })
        .then(function (response) {
            this.loading = false
            this.sent_facilities = response.data
        }.bind(this))
        .catch(function (error) {
            this.loading = false
            console.log(error);
        }.bind(this));
    },
    fetch_GET_unsent_Facilities () {
        axios.get('https://www.lola-inspect.at/api/facilities/inspections/unsent', { headers: { Authorization: this.$store.state.authToken } })
        .then(function (response) {
            this.loading = false
            this.unsent_facilities = response.data
        }.bind(this))
        .catch(function (error) {
            this.loading = false
            console.log(error);
        }.bind(this));
    },
    fetch_GET_both_Facilities () {
        this.fetch_GET_sent_Facilities()
        this.fetch_GET_unsent_Facilities()
        this.resetData()

        this.$router.push('inspektionen');
    },
    fetch_POST_PDF (inspection_id) {
        axios({
            method: 'post',
            url: 'https://www.lola-inspect.at/api/facilities/inspection/sendtouser/' + inspection_id,
            headers: { Authorization: this.$store.state.authToken }
        })
        .then(function (response) {
            if (response.status === 200) {
                this.$store.state.was_Upload_successful = true
                console.log(this.$store.state.facilities_inspection)
                this.$router.push('status')
            } else {
                this.$store.state.was_Upload_successful = false

                this.$router.push('status')
            }
        }.bind(this))
        .catch(function () {
            this.$store.state.was_Upload_successful = false

            this.$router.push('status')
        }.bind(this));
    },
    show_PDF (PDF_link) {
        window.open(PDF_link, '_blank');
    },
    formateDate (date) {
        let _date = new Date(date)
        let _dateString;

        _dateString = ('0' + _date.getDate()).slice(-2) + '.'
        + ('0' + (_date.getMonth()+1)).slice(-2) + '.'
        + _date.getFullYear();
        
        return _dateString
    },
    resetData () {
        this.$store.state.is_Edit_active = true

        const empty_facilities_inspection_mauer = {
            ANL_ID: 0,
            ANL_BEZEICHNUNG: '',
            DB776_CODE: '',

            date: new Date(),
            userName: '',
            userFirstname: '',
            userLastname: '',
            pdfFilename: '',
            pdfSent: false,
            pdfSendTimestamp: new Date(),

            inspectForm: '',
            
            stateClass_values: ['1', '2', '3', '4', '5'],
            stateClass: '',
            stateAdditive_values: ['Kein Zusatz', 'S'],
            stateAdditive: '',
            stateComment: '',

            actionDriveSlowly: false,
            trainrouteBlock: false,
            actionComment: '',

            comment: '',
            images: [],
    
            check: [
                    {
                        id: 1,
                        name: 'Bewuchs: Moos / Gräser',
                        values: ['1', '2', '3', '4', '5'],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Bewuchs: Moos / Gräser',
                            actions_title: 'Bewuchs entfernen',
                            actions: ['ASC', 'AT'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    },
                    {
                        id: 2,
                        name: 'Bewuchs: Sträucher',
                        values: ['1', '2', '3', '4', '5'],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Bewuchs: Sträucher',
                            actions_title: 'Mauerkrone freilegen',
                            actions: ['ASC', 'AT'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    },
                    {
                        id: 3,
                        name: 'Entwässerungsgraben',
                        values: ['1', '2', '3', '4', '5'],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Entwässerungsgraben',
                            actions_title: 'Graben räumen',
                            actions: ['ASC', 'AT'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    },
                    {
                        id: 4,
                        name: 'Rückentwässerung',
                        values: ['1', '2', '3', '4', '5'],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Rückentwässerung',
                            actions_title: 'Entwässerungsöffnungen reinigen ',
                            actions: ['ASC', 'AT'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    },
                    {
                        id: 5,
                        name: 'Entwässerungsfunktion gegeben ',
                        values: ['Ja', 'Nein'],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Entwässerungsfunktion gegeben ',
                            actions_title: 'Verfugung instand setzen',
                            actions: ['Ja', 'Nein'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    },
                    {
                        id: 6,
                        name: 'Ausbrüche / Abplatzungen',
                        values: ['1', '2', '3', '4', '5'],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Ausbrüche / Abplatzungen',
                            actions_title: 'Oberfläche - Risse injizieren',
                            actions: ['ASC', 'AT'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    },
                    {
                        id: 7,
                        name: 'Verfugungsschäden',
                        values: ['1', '2', '3', '4', '5'],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Verfugungsschäden',
                            actions_title: 'Abplatzungen inst. setz. / Einzelsteine',
                            actions: ['ASC', 'AT'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    },
                    {
                        id: 8,
                        name: 'Risse im Beton / Mauerwerk',
                        values: ['1', '2', '3', '4', '5'],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Risse im Beton / Mauerwerk',
                            actions_title: 'Abdeckbalken - neu',
                            actions: ['ASC', 'AT'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    },
                    {
                        id: 9,
                        name: 'Ausbauchungen / Verformung',
                        values: ['1', '2', '3', '4', '5'],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Ausbauchungen / Verformung',
                            actions_title: 'Instand setzen',
                            actions: ['ASC', 'AT'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    },
                    {
                        id: 10,
                        name: 'Absturzsicherung',
                        values: [1, 2, 3],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Absturzsicherung',
                            actions_title: 'Absturzsicherung - neu anbringen',
                            actions: ['ASC', 'AT'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    },
                    {
                        id: 11,
                        name: 'Grabenabdeckung',
                        values: [1, 2, 3],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Grabenabdeckung',
                            actions_title: 'Streichen / befestigen / reparieren',
                            actions: ['ASC', 'AT'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    },
                    {
                        id: 12,
                        name: 'Abdeckbalken',
                        values: [1, 2, 3],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Abdeckbalken',
                            actions_title: 'Erneuerung / Erweiterung',
                            actions: ['ASC', 'AT'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    },
                    {
                        id: 13,
                        name: 'Aufgesetzter Steinschlagschutz',
                        values: [1, 2, 3],
                        selected_value: '',
                        
                        is_action_added: false,
                        action: {
                            field_name: 'Aufgesetzter Steinschlagschutz',
                            actions_title: 'Maßnahme',
                            actions: ['ASC', 'AT'],
                            selected_action: '',
                            deadline_title: 'Fristen',
                            deadline: ''
                        }
                    }
            ]
        }

        const empty_facilities_inspection_durchlass = {
            ANL_ID: 0,
            ANL_BEZEICHNUNG: '',
            DB776_CODE: '',

            date: new Date(),
            userName: '',
            userFirstname: '',
            userLastname: '',
            pdfFilename: '',
            pdfSent: false,
            pdfSendTimestamp: new Date(),

            inspectForm: '',
            
            stateClass_values: ['1', '2', '3', '4', '5'],
            stateClass: '',
            stateAdditive_values: ['Kein Zusatz', 'S'],
            stateAdditive: '',
            stateComment: '',

            actionDriveSlowly: false,
            trainrouteBlock: false,
            actionComment: '',

            comment: '',
            images: [],

            check: [
                {
                    id: 1,
                    name: 'Bewuchs: Moos/Sträucher/etc.',
                    values: ['1', '2', '3', '4', '5'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Bewuchs: Moos/Sträucher/etc.',
                        actions_title: 'Bewuchs entfernen',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 2,
                    name: 'Verschlammung/Anladungen',
                    values: ['1', '2', '3', '4', '5'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Verschlammung/Anladungen',
                        actions_title: 'Durchlass räumen',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 3,
                    name: 'Ausbrüche / Abplatzungen',
                    values: ['1', '2', '3', '4', '5'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Ausbrüche / Abplatzungen',
                        actions_title: 'Ein- u. Auslaufbereich räumen',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 4,
                    name: 'Schäden an Fugen',
                    values: ['1', '2', '3', '4', '5'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Schäden an Fugen',
                        actions_title: 'Ein- und Auslauf befestigen',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 5,
                    name: 'Risse im Beton / Mauerwerk',
                    values: ['1', '2', '3', '4', '5'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Risse im Beton / Mauerwerk',
                        actions_title: 'Fugen instand setzen',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 6,
                    name: 'Ausbauchungen / Verformung',
                    values: ['1', '2', '3', '4', '5'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Ausbauchungen / Verformung',
                        actions_title: 'Oberfläche - Risse injizieren',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 7,
                    name: 'Geländer rdB',
                    values: ['fehlt', '1', '3', '5'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Geländer rdB',
                        actions_title: 'Abplatzungen inst. setz. / Einzelsteine',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 8,
                    name: 'Geländer ldB',
                    values: ['fehlt', '1', '3', '5'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Geländer ldB',
                        actions_title: 'Randbalken - neu',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 9,
                    name: 'Randbalken rdB',
                    values: ['fehlt', '1', '3', '5'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Randbalken rdB',
                        actions_title: 'Instand setzen',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 10,
                    name: 'Randbalken ldB',
                    values: ['fehlt', '1', '3', '5'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Absturzsicherung',
                        actions_title: 'Absturzsicherung - neu anbringen',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 11,
                    name: 'Befestigung Ein-/Auslaufber. ldB',
                    values: ['1', '2', '3'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Befestigung Ein-/Auslaufber. ldB',
                        actions_title: 'Streichen / befestigen / reparieren',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 12,
                    name: 'Befestigung Ein-/Auslaufber. rdB',
                    values: ['1', '2', '3'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Befestigung Ein-/Auslaufber. rdB',
                        actions_title: 'Erneuerung Durchlass',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 13,
                    name: 'Abschluss ldB',
                    values: ['fehlt', '1', '3', '5'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Abschluss ldB',
                        actions_title: 'Durchlass verlängern / Abschluss',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                },
                {
                    id: 14,
                    name: 'Abschluss rdB',
                    values: ['fehlt', '1', '3', '5'],
                    selected_value: '',
                    
                    is_action_added: false,
                    action: {
                        field_name: 'Abschluss rdB',
                        actions_title: 'Maßnahme',
                        actions: ['ASC', 'AT'],
                        selected_action: '',
                        deadline_title: 'Fristen',
                        deadline: ''
                    }
                }
            ]
        }

        this.$store.state.facilities_inspection = empty_facilities_inspection_mauer
        this.$store.state.facilities_inspection = empty_facilities_inspection_durchlass

        this.$store.state.check_mauer = empty_facilities_inspection_mauer.check
        this.$store.state.check_durchlass = empty_facilities_inspection_durchlass.check
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.content {
    margin-bottom: 9rem;
}

.list {
    header {
        margin-bottom: 0.8rem;
    }
}

.list:last-of-type {
    margin-top: 2rem;
}

.list-entry {
    width: 100%;
    height: auto;
    min-height: 4.375rem;
    display: flex;
    align-items: center;
    position: relative;
    background-color: rgba(255, 255, 255, 1);
    border-bottom: 1px solid rgb(230, 230, 230);
    padding-top: 0.6rem;
    padding-bottom: 0.5rem;
    transition: all 0.3s ease-in-out;

    .inner-list-entry {
        cursor: pointer;
        width: 90%;
    }

    h2 {
        font-size: .96rem;
        font-weight: 400;
        line-height: 120%;
    }

    .icon {
        width: 3.75rem;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
    }

    .fa-send {
        width: 20px;
        height: auto;
        display: block;
    }

    &:hover {
        background-color: rgba(252, 252, 252, 1);
    }
}

.list-entry:last-of-type {
    border-bottom: none;
}

.m-adj {
    margin-top: -3px!important;
}

@media all and (min-width: 640px) and (max-width: 1100px) {

}

@media (min-width: 780px) {
    .inner-list-entry {
        width: auto!important;
    }

    .list-entry .icon {
        right: calc(var(--padding) - 20px);
    }
}
</style>